import analyticsEventValues from '@/consts/analytics/analyticsEventValues';
import userBrowserService from '@/services/user/userBrowserService';
import stringUtils from '@/utils/stringUtils';

const getSourceValue = () =>
    userBrowserService.isInStandaloneMode() ? analyticsEventValues.PWA : analyticsEventValues.BROWSER;

const buildQueryFromTemplate = (template) => {
    if (!template) return '';

    const source = getSourceValue();

    return stringUtils.formatByName(template, {
        source: encodeURIComponent(source),
    });
};

export const appendQueryStringTemplate = (link, template) => {
    if (!link || !template) return link;

    const query = buildQueryFromTemplate(template);

    if (!query) return link;

    const normalizedQuery = query.replace(/^[?&]+/, '');

    if (!normalizedQuery) return link;

    const separator = link.includes('?') ? '&' : '?';

    return `${link}${separator}${normalizedQuery}`;
};

export default {
    appendQueryStringTemplate,
};
